export const APPLY_STORED_STATE = 'APPLY_STORED_STATE';
export const CONNECTION_LOST = 'CONNECTION_LOST';
export const CONNECTION_RESTORED = 'CONNECTION_RESTORED';
export const CURRENT_USER_RECEIVE = 'CURRENT_USER_RECEIVE';
export const CURRENT_SUBSCRIPTION_RECEIVE = 'CURRENT_SUBSCRIPTION_RECEIVE';
export const DOCUMENT_HEAD_TITLE_SET = 'DOCUMENT_HEAD_TITLE_SET';
export const MPOS_HTTP_REQUEST = 'MPOS_HTTP_REQUEST';
export const NOTICE_CREATE = 'NOTICE_CREATE';
export const NOTICE_REMOVE = 'NOTICE_REMOVE';
export const ROUTE_SET = 'ROUTE_SET';
export const SECTION_SET = 'SECTION_SET';
export const USERS_RECEIVE = 'USERS_RECEIVE';
export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_REQUEST_SUCCESS = 'USERS_REQUEST_SUCCESS';
export const USERS_REQUEST_FAILURE = 'USERS_REQUEST_FAILURE';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CURRENT_USER_CHARGEBEE_CUSTOMER_RECEIVE = 'CURRENT_USER_CHARGEBEE_CUSTOMER_RECEIVE';
// new

export const SUBSCRIPTIONS_RECEIVE = 'SUBSCRIPTIONS_RECEIVE';
export const SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTIONS_REQUEST';
export const SUBSCRIPTIONS_REQUEST_SUCCESS = 'SUBSCRIPTIONS_REQUEST_SUCCESS';
export const SUBSCRIPTIONS_REQUEST_FAILURE = 'SUBSCRIPTIONS_REQUEST_FAILURE';

export const CURRENT_SUPPORT_RECEIVE = 'CURRENT_SUPPORT_RECEIVE';
export const CURRENT_SUPPORT_REQUEST = 'CURRENT_SUPPORT_REQUEST';
export const CURRENT_SUPPORT_REQUEST_SUCCESS = 'CURRENT_SUPPORT_REQUEST_SUCCESS';
export const CURRENT_SUPPORT_REQUEST_FAILURE = 'CURRENT_SUPPORT_REQUEST_FAILURE';

export const PAYMENT_METHODS_RECEIVE = 'PAYMENT_METHODS_RECEIVE';
export const PAYMENT_METHODS_REQUEST = 'PAYMENT_METHODS_REQUEST';
export const PAYMENT_METHODS_REQUEST_SUCCESS = 'PAYMENT_METHODS_REQUEST_SUCCESS';
export const PAYMENT_METHODS_REQUEST_FAILURE = 'PAYMENT_METHODS_REQUEST_FAILURE';
export const PAYMENT_METHODS_REMOVE_SUCCESS = 'PAYMENT_METHODS_REMOVE_SUCCESS';
export const SET_PRIMARY_PAYMENT_SOURCE_ID = 'SET_PRIMARY_PAYMENT_SOURCE_ID';


export const INVOICES_RECEIVE = 'INVOICES_RECEIVE';
export const INVOICES_REQUEST = 'INVOICES_REQUEST';
export const INVOICES_REQUEST_SUCCESS = 'INVOICES_REQUEST_SUCCESS';
export const INVOICES_REQUEST_FAILURE = 'INVOICES_REQUEST_FAILURE';

export const SUPPORT_PLANS_RECEIVE = 'SUPPORT_PLANS_RECEIVE';
export const SUPPORT_PLANS_REQUEST = 'SUPPORT_PLANS_REQUEST';
export const SUPPORT_PLANS_REQUEST_SUCCESS = 'SUPPORT_PLANS_REQUEST_SUCCESS';
export const SUPPORT_PLANS_REQUEST_FAILURE = 'SUPPORT_PLANS_REQUEST_FAILURE';

export const WEB_PLANS_RECEIVE = 'WEB_PLANS_RECEIVE';
export const WEB_PLANS_REQUEST = 'WEB_PLANS_REQUEST';
export const WEB_PLANS_REQUEST_SUCCESS = 'WEB_PLANS_REQUEST_SUCCESS';
export const WEB_PLANS_REQUEST_FAILURE = 'WEB_PLANS_REQUEST_FAILURE';

export const CURRENT_WEB_RECEIVE = 'CURRENT_WEB_RECEIVE';
export const CURRENT_WEB_REQUEST = 'CURRENT_WEB_REQUEST';
export const CURRENT_WEB_REQUEST_SUCCESS = 'CURRENT_WEB_REQUEST_SUCCESS';
export const CURRENT_WEB_REQUEST_FAILURE = 'CURRENT_WEB_REQUEST_FAILURE';

export const ADDONS_RECEIVE = 'ADDONS_RECEIVE';
export const ADDONS_REQUEST = 'ADDONS_REQUEST';
export const ADDONS_REQUEST_SUCCESS = 'ADDONS_REQUEST_SUCCESS';
export const ADDONS_REQUEST_FAILURE = 'ADDONS_REQUEST_FAILURE';

export const COUPONS_RECEIVE = 'COUPONS_RECEIVE';
export const COUPONS_REQUEST = 'COUPONS_REQUEST';
export const COUPONS_REQUEST_SUCCESS = 'COUPONS_REQUEST_SUCCESS';
export const COUPONS_REQUEST_FAILURE = 'COUPONS_REQUEST_FAILURE';


export const EXPIRED_CUSTOMERS_RECEIVE = 'EXPIRED_CUSTOMERS_RECEIVE';
export const EXPIRED_CUSTOMERS_REQUEST = 'EXPIRED_CUSTOMERS_REQUEST';
export const EXPIRED_CUSTOMERS_REQUEST_SUCCESS = 'EXPIRED_CUSTOMERS_REQUEST_SUCCESS';
export const EXPIRED_CUSTOMERS_REQUEST_FAILURE = 'EXPIRED_CUSTOMERS_REQUEST_FAILURE';

export const RENTAL_PLANS_RECEIVE = 'RENTAL_PLANS_RECEIVE';
export const RENTAL_PLANS_REQUEST = 'RENTAL_PLANS_REQUEST';
export const RENTAL_PLANS_REQUEST_SUCCESS = 'RENTAL_PLANS_REQUEST_SUCCESS';
export const RENTAL_PLANS_REQUEST_FAILURE = 'RENTAL_PLANS_REQUEST_FAILURE';

export const CURRENT_RENTAL_RECEIVE = 'CURRENT_RENTAL_RECEIVE';
export const CURRENT_RENTAL_REQUEST = 'CURRENT_RENTAL_REQUEST';
export const CURRENT_RENTAL_REQUEST_SUCCESS = 'CURRENT_RENTAL_REQUEST_SUCCESS';
export const CURRENT_RENTAL_REQUEST_FAILURE = 'CURRENT_RENTAL_REQUEST_FAILURE';

export const CURRENT_RETAILER_RENTAL_RECEIVE = 'CURRENT_RETAILER_RENTAL_RECEIVE';
export const CURRENT_RETAILER_RENTAL_REQUEST = 'CURRENT_RETAILER_RENTAL_REQUEST';
export const CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS = 'CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS';
export const CURRENT_RETAILER_RENTAL_REQUEST_FAILURE = 'CURRENT_RETAILER_RENTAL_REQUEST_FAILURE';

export const CLOUD_HOSTING_PLANS_RECEIVE = 'CLOUD_HOSTING_PLANS_RECEIVE';
export const CLOUD_HOSTING_PLANS_REQUEST = 'CLOUD_HOSTING_PLANS_REQUEST';
export const CLOUD_HOSTING_PLANS_REQUEST_SUCCESS = 'CLOUD_HOSTING_PLANS_REQUEST_SUCCESS';
export const CLOUD_HOSTING_PLANS_REQUEST_FAILURE = 'CLOUD_HOSTING_PLANS_REQUEST_FAILURE';

export const CURRENT_CLOUD_HOSTING_RECEIVE = 'CURRENT_CLOUD_HOSTING_RECEIVE';
export const CURRENT_CLOUD_HOSTING_REQUEST = 'CURRENT_CLOUD_HOSTING_REQUEST';
export const CURRENT_CLOUD_HOSTING_REQUEST_SUCCESS = 'CURRENT_CLOUD_HOSTING_REQUEST_SUCCESS';
export const CURRENT_CLOUD_HOSTING_REQUEST_FAILURE = 'CURRENT_CLOUD_HOSTING_REQUEST_FAILURE';

export const DISPATCH_PLANS_RECEIVE = 'DISPATCH_PLANS_RECEIVE';
export const DISPATCH_PLANS_REQUEST = 'DISPATCH_PLANS_REQUEST';
export const DISPATCH_PLANS_REQUEST_SUCCESS = 'DISPATCH_PLANS_REQUEST_SUCCESS';
export const DISPATCH_PLANS_REQUEST_FAILURE = 'DISPATCH_PLANS_REQUEST_FAILURE';

export const CURRENT_DISPATCH_RECEIVE = 'CURRENT_DISPATCH_RECEIVE';
export const CURRENT_DISPATCH_REQUEST = 'CURRENT_DISPATCH_REQUEST';
export const CURRENT_DISPATCH_REQUEST_SUCCESS = 'CURRENT_DISPATCH_REQUEST_SUCCESS';
export const CURRENT_DISPATCH_REQUEST_FAILURE = 'CURRENT_DISPATCH_REQUEST_FAILURE';

export const CLOUD_BACKUP_PLANS_RECEIVE = 'CLOUD_BACKUP_PLANS_RECEIVE';
export const CLOUD_BACKUP_PLANS_REQUEST = 'CLOUD_BACKUP_PLANS_REQUEST';
export const CLOUD_BACKUP_PLANS_REQUEST_SUCCESS = 'CLOUD_BACKUP_PLANS_REQUEST_SUCCESS';
export const CLOUD_BACKUP_PLANS_REQUEST_FAILURE = 'CLOUD_BACKUP_PLANS_REQUEST_FAILURE';

export const CURRENT_CLOUD_BACKUP_RECEIVE = 'CURRENT_CLOUD_BACKUP_RECEIVE';
export const CURRENT_CLOUD_BACKUP_REQUEST = 'CURRENT_CLOUD_BACKUP_REQUEST';
export const CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS = 'CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS';
export const CURRENT_CLOUD_BACKUP_REQUEST_FAILURE = 'CURRENT_CLOUD_BACKUP_REQUEST_FAILURE';

export const BARCODE_LOOKUP_PLANS_RECEIVE = 'BARCODE_LOOKUP_PLANS_RECEIVE';
export const BARCODE_LOOKUP_PLANS_REQUEST = 'BARCODE_LOOKUP_PLANS_REQUEST';
export const BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS = 'BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS';
export const BARCODE_LOOKUP_PLANS_REQUEST_FAILURE = 'BARCODE_LOOKUP_PLANS_REQUEST_FAILURE';

export const CURRENT_BARCODE_LOOKUP_RECEIVE = 'CURRENT_BARCODE_LOOKUP_RECEIVE';
export const CURRENT_BARCODE_LOOKUP_REQUEST = 'CURRENT_BARCODE_LOOKUP_REQUEST';
export const CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS = 'CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS';
export const CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE = 'CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE';

export const ROAM_PLANS_RECEIVE = 'ROAM_PLANS_RECEIVE';
export const ROAM_PLANS_REQUEST = 'ROAM_PLANS_REQUEST';
export const ROAM_PLANS_REQUEST_SUCCESS = 'ROAM_PLANS_REQUEST_SUCCESS';
export const ROAM_PLANS_REQUEST_FAILURE = 'ROAM_PLANS_REQUEST_FAILURE';

export const CURRENT_ROAM_RECEIVE = 'CURRENT_ROAM_RECEIVE';
export const CURRENT_ROAM_REQUEST = 'CURRENT_ROAM_REQUEST';
export const CURRENT_ROAM_REQUEST_SUCCESS = 'CURRENT_ROAM_REQUEST_SUCCESS';
export const CURRENT_ROAM_REQUEST_FAILURE = 'CURRENT_ROAM_REQUEST_FAILURE';

export const CURRENT_TSPAY_RECEIVE = 'CURRENT_TSPAY_RECEIVE';
export const CURRENT_TSPAY_REQUEST = 'CURRENT_TSPAY_REQUEST';
export const CURRENT_TSPAY_REQUEST_SUCCESS = 'CURRENT_TSPAY_REQUEST_SUCCESS';
export const CURRENT_TSPAY_REQUEST_FAILURE = 'CURRENT_TSPAY_REQUEST_FAILURE';

export const PLAN_NAMES_RECEIVE = 'PLAN_NAMES_RECEIVE';
export const PLAN_NAMES_REQUEST = 'PLAN_NAMES_REQUEST';
export const PLAN_NAMES_REQUEST_SUCCESS = 'PLAN_NAMES_REQUEST_SUCCESS';
export const PLAN_NAMES_REQUEST_FAILURE = 'PLAN_NAMES_REQUEST_FAILURE';

export const CURRENT_SUBSCRIPTION_REQUEST = 'CURRENT_SUBSCRIPTION_REQUEST';
export const CURRENT_SUBSCRIPTION_REQUEST_SUCCESS = 'CURRENT_SUBSCRIPTION_REQUEST_SUCCESS';
export const CURRENT_SUBSCRIPTION_REQUEST_FAILURE = 'CURRENT_SUBSCRIPTION_REQUEST_FAILURE';

export const KIOSK_PLANS_RECEIVE = 'KIOSK_PLANS_RECEIVE';
export const KIOSK_PLANS_REQUEST = 'KIOSK_PLANS_REQUEST';
export const KIOSK_PLANS_REQUEST_SUCCESS = 'KIOSK_PLANS_REQUEST_SUCCESS';
export const KIOSK_PLANS_REQUEST_FAILURE = 'KIOSK_PLANS_REQUEST_FAILURE';

export const CURRENT_KIOSK_RECEIVE = 'CURRENT_KIOSK_RECEIVE';
export const CURRENT_KIOSK_REQUEST = 'CURRENT_KIOSK_REQUEST';
export const CURRENT_KIOSK_REQUEST_SUCCESS = 'CURRENT_KIOSK_REQUEST_SUCCESS';
export const CURRENT_KIOSK_REQUEST_FAILURE = 'CURRENT_KIOSK_REQUEST_FAILURE';

export const VISUALDECK_PLANS_RECEIVE = 'VISUALDECK_PLANS_RECEIVE';
export const VISUALDECK_PLANS_REQUEST = 'VISUALDECK_PLANS_REQUEST';
export const VISUALDECK_PLANS_REQUEST_SUCCESS = 'VISUALDECK_PLANS_REQUEST_SUCCESS';
export const VISUALDECK_PLANS_REQUEST_FAILURE = 'VISUALDECK_PLANS_REQUEST_FAILURE';

export const CURRENT_VISUALDECK_RECEIVE = 'CURRENT_VISUALDECK_RECEIVE';
export const CURRENT_VISUALDECK_REQUEST = 'CURRENT_VISUALDECK_REQUEST';
export const CURRENT_VISUALDECK_REQUEST_SUCCESS = 'CURRENT_VISUALDECK_REQUEST_SUCCESS';
export const CURRENT_VISUALDECK_REQUEST_FAILURE = 'CURRENT_VISUALDECK_REQUEST_FAILURE';

export const UNIVERSALIMPORTER_PLANS_RECEIVE = 'UNIVERSALIMPORTER_PLANS_RECEIVE';
export const UNIVERSALIMPORTER_PLANS_REQUEST = 'UNIVERSALIMPORTER_PLANS_REQUEST';
export const UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS = 'UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS';
export const UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE = 'UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE';

export const CURRENT_UNIVERSALIMPORTER_RECEIVE = 'CURRENT_UNIVERSALIMPORTER_RECEIVE';
export const CURRENT_UNIVERSALIMPORTER_REQUEST = 'CURRENT_UNIVERSALIMPORTER_REQUEST';
export const CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS = 'CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS';
export const CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE = 'CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE';